<template>
  <!-- 新用户充值流水控制 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="新用户充值流水控制"
      width="700px"
      @close="closeConfigDialog"
    >
      <div v-loading="dialogLoading">
        <p class="text-line">
          <el-switch
            v-model="backListSwitch"
            :active-value="1"
            :inactive-value="0"
            active-text="打开"
            inactive-text="关闭"
            @change="setSwitch"
          >
          </el-switch>
        </p>
        <p class="text-line" v-for="(item, index) in lineList" :key="index">
          &nbsp;当日充值&nbsp;
          <el-input
            style="width: 150px"
            v-model="item.recharge_amount"
            placeholder="请输入限制金额"
          ></el-input>
          &nbsp;及以下控制出不了&nbsp;
          <el-input
            style="width: 150px"
            v-model="item.prize_amount"
            placeholder="请输入限制金额"
          ></el-input>
          &nbsp;及以上的&nbsp;
          <i
            v-if="lineList.length > 1"
            class="el-icon-remove-outline reduce_btn"
            @click="reduceTextLine(index)"
          ></i>
          <i
            v-if="lineList.length - 1 === index"
            class="el-icon-circle-plus-outline add_btn"
            @click="addTextLine"
          ></i>
        </p>
        <p class="btn-box">
          <el-button @click="closeConfigDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { delApiData, getApiData, postApiData, patchApiData } from '../../http'
export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: 1
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogLoading: false,//弹窗加载动画
      buttonLoading: false,//按钮加载动画
      backListSwitch: 0,//打开或关闭 0是关闭 1是打开
      rechargeAmount: undefined,//开箱流水控制的充值金额
      lineList: [{ recharge_amount: 0, prize_amount: 0 }],//设置弹窗初始数据
    }
  },
  computed: {
    showMark: {//显示标志
      get() {
        return this.visible
      },
      set() { }
    },
    typeNum:{//弹窗类型
      get() {
        return this.value
      },
      set() { }
    }
  },
  watch: {
    showMark: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getBackListSwitch()
          this.getConfigList()
        }
      },
    }
  },
  created() {

  },
  methods: {
    getBackListSwitch(val) {
      //获取新用户充值流水开关状态
      getApiData('recharge_open_white')
        .then(res => {
          if (res && res.data) {
            this.backListSwitch = 1
          } else {
            this.backListSwitch = 0
          }
        })
    },
    setSwitch(val) {
      //打开或关闭取新用户充值流水控制开关
      let params = {
        black: val
      }
      patchApiData('recharge_open_white', params)
        .then(res => {
          this.$message.success("操作成功！")
        }).catch(err => {
          //修改失败还原按钮
          if (val === 1) {
            this.backListSwitch = 0
          } else {
            this.backListSwitch = 1
          }
        })
    },
    getConfigList() {
      //获取设置列表数据
      this.dialogLoading = true
      // open_box_limit 接口后跟1是充值流水,2是开箱流水,3是新用户开箱流水
      getApiData(`open_box_limit/3`)
        .then(res => {
          if (res) {
            if (res.length > 0) {
              //不为空时赋值
              this.lineList = res
            }
          }
        }).finally(() => {
          this.dialogLoading = false
        })
    },
    addTextLine() {
      //加行
      let params = { recharge_amount: 0, prize_amount: 0 }
      this.lineList.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.lineList.splice(num, 1)
    },
    submit() {
      //保存编辑好的表单信息
      this.buttonLoading = true
      let params
      if (this.lineList.length === 1) {
        if ((!this.lineList[0].recharge_amount || this.lineList[0].recharge_amount == 0) && (!this.lineList[0].prize_amount || this.lineList[0].prize_amount == 0)) {
          params = { data: [] };
        } else {
          params = { data: this.lineList };
        }
      } else {
        params = { data: this.lineList };
      }
      // open_box_limit 接口后跟1是充值流水,2是开箱流水,3是新用户开箱流水
      patchApiData(`open_box_limit/3`, params)
        .then(res => {
          this.$message.success("保存成功！")
          this.closeConfigDialog()//关闭弹窗
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    closeConfigDialog() {
      //关闭弹窗
      this.$emit('close')
      this.backListSwitch = 0//开关还原为关闭
      this.lineList = [{ recharge_amount: 0, prize_amount: 0 }]//还原数据
    },
  }
}
</script>
<style lang="less" scoped>
</style>